module.exports = __webpack_public_path__ + "img/avatar3.0489e901.png";